<template>
	<div class="SocialmediaCronArchiveList">
		
		<template v-if="isLoading">
			<div class="text-xs-center pa-5">
				<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
				<div class="caption mt-4">Listeleniyor</div>
			</div>
		</template>
		<template v-if="!isLoading"> 
			<div class="text-xs-center mb-4 mt-2">
				<v-btn round color="teal" outline  @click="loadItems()">Listeyi Yenile</v-btn>
			</div>
		</template>

		<div class="archiveItems">
			<div class="archiveItem" v-for="(item,itemIndex) in items" :key="itemIndex">
				<a :href="item.src" target="_blank">
					<img :src="item.thumbnail" alt="">
				</a>
			</div>
		</div>
  
	</div>
</template>


<script>
export default {
	name : "SocialmediaCronArchiveList",
	data : () => ({
		isLoading : true,
		items : []
	}),
	mounted(){
		this.loadItems()
	},
	methods : {
		loadItems(){
			this.isLoading = true;
			this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cron/archive/", {
				params: { }
			}).then(response => {
				this.items = response.body; 
				this.isLoading = false;
			})
		}
	}
}
</script>


<style lang="less">
	.SocialmediaCronArchiveList{
		padding : 15px;
		.archiveItems{
			text-align: center;
			.archiveItem{
				border:3px solid #999;
				width : 86px;
				height : 86px;
				display: inline-block;
				margin:3px;
				&:hover{
					border:3px solid rgb(32, 109, 224);
				}
				a{
					display: block;
					width : 100%;
					height : 100%;
					img{
						width : 100%;
						height : 100%;
						object-fit:cover;
					}
				}
			}
		}
	}
</style>
